import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('reporting-data', {
  library: 'reporting-data'
});